<div class="content-status-bar">
  <div class="textTitles">
    <p class="title">Alertas por estado</p>
    <p class="percentageText">Porcentaje</p>
  </div>
  <div *ngFor="let data of barsDataStatus">
    <div class="divProgress">
      <p class="titleAmount">{{ data.title }}({{ data.amount }})</p>
      <div class="divPercentage">
        <mat-progress-bar
          [ngClass]="data.status"
          [color]="data.color"
          [value]="((data.amount * 100) / total).toFixed()"
        >
        </mat-progress-bar>
        <p>{{ ((data.amount * 100) / total).toFixed(2) }}%</p>
      </div>
    </div>
    <div class="separatorLine"></div>
  </div>
</div>
